import {Form, Input, Select} from 'antd';
import {useQuery} from 'react-query';
import api from '../../api';
import {greetings} from '../../constants';

const InvitationForm = ({form, onFinish}) => {

  const {data: {data: statusList = []} = {}} = useQuery(['statuses'],
    async () => {
      return await api.meetings.statusList();
    }, {
      cacheTime: Infinity,
    });
  const {data: {data: stateList = []} = {}} = useQuery(['states'],
    async () => {
      return await api.meetings.stateList();
    }, {
      cacheTime: Infinity,
    });

  return (
    <Form
      form={form}
      name="InvitationForm"
      labelCol={{span: 8}}
      wrapperCol={{span: 16}}
      layout="horizontal"
      onFinish={onFinish}
    >
      <Form.Item label="Anrede" name="greeting">
        <Select allowClear>
          {greetings?.map(item => <Select.Option key={item.value}
                                          value={item.value}>{item.label}</Select.Option>)}
        </Select>
      </Form.Item>

      <Form.Item label="Titel" name="title">
        <Input/>
      </Form.Item>

      <Form.Item label="Grad" name="grad">
        <Input/>
      </Form.Item>

      <Form.Item label="Nachname" name="last_name" rules={[{required: true}]}>
        <Input/>
      </Form.Item>
      <Form.Item label="Vorname" name="first_name" rules={[{required: true}]}>
        <Input/>
      </Form.Item>
      <Form.Item label="Firma" name="company">
        <Input/>
      </Form.Item>
      <Form.Item label="Straße, Nr." name="address">
        <Input/>
      </Form.Item>
      <Form.Item label="PLZ" name="post_index">
        <Input/>
      </Form.Item>
      <Form.Item label="Ort" name="area">
        <Input/>
      </Form.Item>
      <Form.Item label="Bundesland" name="state">
        <Select allowClear>
          {stateList.map(item => <Select.Option key={item.id} value={item.id}>
            {item.name}</Select.Option>)}
        </Select>
      </Form.Item>
      <Form.Item label="Telefon" name="phone">
        <Input/>
      </Form.Item>
      <Form.Item label="E-mail" name="email" rules={[{required: true}]}>
        <Input/>
      </Form.Item>
      <Form.Item label="Teilnehmerstatus" name="status" rules={[{required: true}]}>
        <Select>
          {statusList.map(item => <Select.Option key={item.id} value={item.id}>
            {item.name}</Select.Option>)}
        </Select>
      </Form.Item>
    </Form>
  );
};

export default InvitationForm;
